const MESSAGES = {
  added_item_success: 'Artikel wurde in den Warenkorb gelegt.',
  fill_out_item: 'Bitte {field} ausfüllen',
  success_placing: 'Vielen Dank für Ihre {label}. Eine Bestätigung erhalten Sie per E-Mail.',
  success_config_update: 'Einstellung wurde angepasst',
  success_user_update: 'Ihre Daten wurden angepasst',
  qr_found_searching: 'QR-Code gefunden. Suche nach Produkt...',
  product_not_found: 'Produkt nicht gefunden...',
  password_not_same: 'Passwörter stimmen nicht überein',
  password_at_least_digits: 'Passwort muss mindestens {count} Zeichen beinhalten',
  successful_password_reset: 'Ihr Passwort wurde geändert.',
  no_user: 'User nicht gefunden',
  missing_params: 'Fehlende Parameter',
  password_forgot_mail_sent: 'Erfolg! Eine E-Mail ist unterwegs',
  no_email: 'Keine E-Mail gefunden',
  password_change_failed: 'Passwortänderung fehlgeschlagen',
  mixer_request_success: 'Ihre Anfrage wurde gesendet.',
  sand_amount_under_100: 'Sie benötigen 100%',
};

export default MESSAGES;
